export default __webpack_public_path__ + "static/media/Vertical_AHU_1_selected.a9088a35.svg";